import { render } from "./HeaderAd.vue?vue&type=template&id=0901fc94&scoped=true"
import script from "./HeaderAd.vue?vue&type=script&lang=js"
export * from "./HeaderAd.vue?vue&type=script&lang=js"

import "./HeaderAd.vue?vue&type=style&index=0&id=0901fc94&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0901fc94"]])

export default __exports__